import { useQuery } from "@tanstack/react-query";
import { EnterpriseFailureHandlerFailureCount } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
const fetchFailureCountOverview = () => EnterpriseFailureHandlerFailureCount.count();
const useFailuresOverview = () => {
  const { data, refetch, isLoading, error, isSuccess } = useQuery({
    queryKey: ["failures", "counts"],
    queryFn: () => defaultOnError(
      fetchFailureCountOverview(),
      "Loading failure counts failed with status",
      "Could not load failure counts stats."
    ),
    notifyOnChangeProps: ["data", "error"]
  });
  return {
    data,
    refetch,
    isLoading,
    error,
    isSuccess
  };
};
export default useFailuresOverview;
